export default __webpack_public_path__ + "static/media/TY23_SDCF_F8937_Common_Final Package- Signed.ec511667.pdf";